/**
 * 既定値は server側の config/app.php の limitCartUnitCount(40) と揃える必要がある。
 * ずれた場合、clientが提示する選択範囲とserverが受け付ける範囲が食い違う。
 */
const DEFAULT_LIMIT_CART_UNIT_COUNT = '40'

export default class CartEnvironmentService {
  get limitCartUnitCount(): number {
    return parseInt(process.env.LIMIT_CART_UNIT_COUNT || DEFAULT_LIMIT_CART_UNIT_COUNT, 10)
  }
}
